/**
 * <product-form> — wraps the add-to-cart form. Submits via fetch to /cart/add.js,
 * dispatches "cart:updated" on ThemeBus, and triggers cart-drawer to refresh.
 */
class ProductForm extends globalThis.ThemeElement {
  connectedCallback() {
    this.form = this.$('form');
    this.submitBtn = this.$('[data-add-to-cart]');
    if (!this.form || !this.submitBtn) return;
    this.on(this.form, 'submit', this.onSubmit.bind(this));
  }

  async onSubmit(e) {
    e.preventDefault();
    if (this.submitBtn.disabled) return;
    this.submitBtn.classList.add('is-loading');
    this.submitBtn.disabled = true;
    const labelEl = this.submitBtn.querySelector('[data-add-label]');
    const originalLabel = labelEl?.textContent;
    if (labelEl && labelEl.dataset.addingLabel) labelEl.textContent = labelEl.dataset.addingLabel;

    const formData = new FormData(this.form);
    formData.append('sections', 'cart-drawer,header');
    try {
      const res = await fetch(`${globalThis.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Add to cart failed');
      }
      const data = await res.json();
      globalThis.ThemeBus.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: data, sections: data.sections } }));
      globalThis.ThemeBus.dispatchEvent(new CustomEvent('cart:open'));
      this.emit('cart:add', { item: data });
    } catch (err) {
      console.error('product-form add', err);
      if (labelEl) labelEl.textContent = labelEl.dataset.errorLabel || 'Try again';
    } finally {
      this.submitBtn.classList.remove('is-loading');
      this.submitBtn.disabled = false;
      if (labelEl && originalLabel) {
        setTimeout(() => { labelEl.textContent = originalLabel; }, 1200);
      }
    }
  }
}
if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);
